import React from 'react'

import { Element, Text } from "components/shared/base"
import FourColumnItem from "./FourColumnItem"
import {
  PrismicHomepageDataBodyFourColumnItem,
  PrismicHomepageDataBodyFourColumnPrimary
} from "types/__generated__/gatsby-graphql"

interface OwnProps {
  items: PrismicHomepageDataBodyFourColumnItem[]
}

export type FourColumnProps = OwnProps & PrismicHomepageDataBodyFourColumnPrimary

const FourColumn: React.FC<FourColumnProps> = ({
  border_above_repeatable_items = true,
  headline,
  items
}): React.ReactElement => {

  const headlineText = headline?.text || "";

  return (
    <Element
      as="section"
      color="textPrimary"
      fontSize={["text.primaryMobile", "text.primary"]}
      lineHeight="primary"
      m="45px 20px"
    >
      <Element m="0 auto" maxWidth="contentWidth">
        {headlineText && (
          <Text as="h2" textAlign="center">{headlineText}</Text>
        )}
        <Element
          display="grid"
          gridColumnGap="25px"
          gridTemplateColumns="repeat(12, 1fr)"
        >
          {items?.map((item, index) => (
            <FourColumnItem
              key={index}
              index={index}
              item={item}
              borderAboveItems={border_above_repeatable_items}
            />
          ))}
        </Element>
      </Element>
    </Element>
  )
}

export default FourColumn
